import { Link } from "react-router-dom";
import { MENU_LIST, UNIV_MENU_LIST } from "../../../../utils/config";
import styles from "./Top.module.scss";
import stylesMain from "../../../layout/admin/Main.module.scss";
import { useAuth } from "../../../../contexts/AuthContext";
import { AUTH_UNIVERSITY } from "../../../../utils/config";

const Top = () => {
  // ユーザー情報
  const { user } = useAuth();
  let menuList = MENU_LIST;
  // 権限確認
  if (user.authority == AUTH_UNIVERSITY) {
    menuList = UNIV_MENU_LIST;
  }
  return (
    <div>
      {" "}
      <nav className={stylesMain.main}>
        <ul className={styles.topnav}>
          {menuList.map((menu) => (
            <li className={styles.topnav__item}>
              <Link to={menu.url} className={styles.topnav__link}>
                <span>{menu.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};
export default Top;
